export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.ed9975a5.otf";